import jwtAxios from "../auth/index";
export default jwtAxios;